import React from 'react';


import { DataGrid, GridValueGetterParams } from '@mui/x-data-grid';
import { Container, Button, Grid, Stack, Typography, Checkbox, Box, InputBase, IconButton, Divider } from '@mui/material';

import moment from 'moment';


import * as Api from "api";

import * as CardsApi from 'api/order'

import ErrorMessage from 'tsui/ErrorMessage'
import CardDetailsModal from '../../../home/tabs/Cards/CardDetailsModal';
import GetCardOrders from '../cards/GetCardOrders';

import DirectionsIcon from '@mui/icons-material/Directions';
import BackspaceIcon from '@mui/icons-material/Backspace';

export class CardOrdersData {
    orderId: string;
    userId!: string;
    // order: string;
    activated: string | boolean;
    orderDate: Date;
    // clientEmail: string;
    guiCardDate: Date | undefined; //TODO DATE

    template: string;
    cardType: string;

    cardBusiness?: string;
    cardPersonal?: string;

    shippingStatus?: boolean;
    shippingAddress?: string;
    clientFullName?: string;
    clientPhoneNum?: string;



    constructor(c: CardsApi.ApiCardOrders) {

        this.orderId = c.orderId;
        this.cardType = c.cardType;
        // this.order = c.order;
        this.activated = c.activated
        this.guiCardDate = c.guiCardDate
        // this.clientEmail = c.clientEmail
        this.orderDate = c.orderDate
        this.userId = c.userId
        this.template = c.template;
        this.shippingAddress = c.shippingAddress
        this.clientFullName = c.clientFullName
        this.clientPhoneNum = c.clientPhoneNum

        if (c.shoppingCart) {
            for (let cartInfo of c.shoppingCart) {
                if (cartInfo.cardType === 'B') {
                    this.cardBusiness = `${cartInfo.quantity} count - ${cartInfo.amount} ${cartInfo.currency}`
                }
                if (cartInfo.cardType === 'P') {
                    this.cardPersonal = `${cartInfo.quantity} count - ${cartInfo.amount} ${cartInfo.currency}`
                }
            }
        }
    }
}

export default function CardOrdersTab() {

    const mounted = React.useRef(false);
    const [dataRequested, setDataRequested] = React.useState(false);
    let [error, setError] = React.useState<Error | null>(null);
    //let [cards, setCards] = React.useState<CardsApi.ApiCard[]>();
    const [cards, setCards] = React.useState<CardOrdersData[] | null>(null);
    let [cardDetailsId, setCardDetailsId] = React.useState<string | null>(null);
    let [showAddUser, setShowAddUser] = React.useState(false);
    let [activateCard, setActivateCard] = React.useState<string | null>(null);

    const [shippedStatus, setShippedStatus] = React.useState(true);
    const [shippedStatusString, setShippedStatusString] = React.useState('true');

    const [searchVal, setSearchVal] = React.useState('');



    React.useEffect(() => {
        mounted.current = true;
        if (!dataRequested) {
            console.log('searchVal')
            Api.requestAdmin<CardsApi.ApiCardOrders[]>('orders', 'fetch', { shippedStatus: shippedStatusString, searchVal: searchVal === '' ? 'empty' : searchVal }).then(cards => {
                if (mounted.current) {
                    //setCards(cards);
                    let cardsData: CardOrdersData[] = [];
                    for (let c of cards) {
                        cardsData.push(new CardOrdersData(c));
                    }

                    setCards(cardsData)
                }
            }).catch(setError);
            setDataRequested(true);
            return;
        }
        return () => { mounted.current = false }
    }, [dataRequested]);



    const handleLangChange = React.useCallback((event) => {

        if (event.target.id === 'shippedStatus') {
            setShippedStatus(event.target.checked);
            if (event.target.checked === true) {
                setShippedStatusString('true');
                setDataRequested(false);
            } else {
                setShippedStatusString('false');
                setDataRequested(false);
            }
        }
    }, []);


    const onSearchTextRemove = React.useCallback(() => {
        setSearchVal('')
        setDataRequested(false)
    }, [])

    const onSearchTextSubmit = React.useCallback((e) => {

        if(e.target.value === undefined) {
            return;
        }

        setSearchVal(e.target.value)
        setDataRequested(false)
    }, [])


    const searchTextChange = React.useCallback((e) => {
        console.log('searchTextChange', e.target.value)

        setSearchVal(e.target.value)
        if (e.target.value === '') {
            setDataRequested(false)
        }
        setDataRequested(false)

    }, [])

    const onSubmit = React.useCallback((e) => {
        return;
        // if(searchVal === '' || searchVal === undefined) return;
        
        // // e.preventDefault();
        // setDataRequested(false)

    }, [])



    if (error) {
        console.debug(error);
        return <ErrorMessage error={error} />
    }

    if (!cards) {
        return <></>
    }


    return <>
        <Grid container height='100%'>

            {/* <AdminTabTitle>Cards</AdminTabTitle> */}

            <Grid item xs={10} md={10}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography>Orders:&nbsp;{cards.length}</Typography>
                    <Checkbox
                        id='shippedStatus'
                        name='shippedStatus'
                        onChange={handleLangChange}
                        checked={shippedStatus}
                        sx={{ ml: 8 }}
                    />
                    <Typography>Shipped</Typography>

                    <form onSubmit={onSubmit} style={{ display: 'flex', backgroundColor: '#242c37' }}>

                        <InputBase
                            sx={{ ml: 1, flex: 1, }}
                            placeholder='Search'
                            inputProps={{ 'aria-label': 'search google maps' }}
                            // onChange={(e) => {setSearchVal(e.target.value)}}
                            onChange={(e) => {searchTextChange(e)}}
                            value={searchVal}
                        />
                        <IconButton type='button' sx={{ p: '10px' }} aria-label='search' onClick={onSearchTextRemove}>
                            <BackspaceIcon />
                        </IconButton>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
                        <Button onClick={onSearchTextSubmit}>
                            <DirectionsIcon />
                        </Button>
                    </form>
                    
                </Box>
            </Grid>

            {/* <Stack direction='row' sx={{ width: '100%' }}>
                <Typography sx={{ flexGrow: 1 }}>Total Cards:&nbsp;{cards.length}</Typography>

            </Stack> */}



            <Grid item md={2} alignItems='right'>
                <Button variant='contained' onClick={() => { setShowAddUser(true) }}>Add Card</Button>
            </Grid>
            <Grid item xs height='100%'>

                <DataGrid
                    sx={{
                        color: theme_.dataGridTextColor
                    }}
                    columns={[
                        // { field: 'template', headerName: 'template Version', headerAlign: 'center', width: 80 },
                        { field: 'userId', headerName: 'User Id', headerAlign: 'center', width: 80 },
                        { field: 'orderId', headerName: 'Order Id', headerAlign: 'center', width: 120 },
                        // {
                        //     field: 'order', headerName: 'Order', headerAlign: 'center', width: 100, renderCell: (params) => {
                        //         return <>
                        //             {params.row.activated === true && <Typography sx={{ color: 'green' }}>{params.row.order}</Typography>}
                        //             {params.row.activated === false && <Typography sx={{ color: 'red' }}>{params.row.order}</Typography>}

                        //         </>;
                        //     }
                        // },
                        { field: 'cardType', headerName: 'Card Type', headerAlign: 'center', width: 80 },
                        // { field: 'clientEmail', headerName: 'Client Email', headerAlign: 'center', width: 250 },



                        { field: 'cardBusiness', headerName: 'Business Card', headerAlign: 'center', width: 300 },
                        { field: 'cardPersonal', headerName: 'Personal Card', headerAlign: 'center', width: 300 },

                        { field: 'shippingAddress', headerName: 'Shipping Address', headerAlign: 'center', width: 200 },
                        { field: 'clientFullName', headerName: 'Client FullName', headerAlign: 'center', width: 200 },
                        { field: 'clientPhoneNum', headerName: 'Client Phone Number', headerAlign: 'center', width: 200 },

                        // {
                        //     field: 'orderDate', headerName: 'Order Date', type: 'date', width: 300,
                        //     valueGetter: (cell: GridValueGetterParams<CardsApi.ApiCardOrders>) => JSON.stringify(cell.row.orderDate),
                        // },
                        {
                            field: 'orderDate', headerName: 'Order Date', type: 'date', flex: 1,
                            valueFormatter: params => moment(params?.value).format("DD.MM.YYYY HH:mm"),
                        },


                        // {
                        //     field: 'cardDate', headerName: 'Card Date', type: 'date', flex: 1,
                        // },


                        // {
                        //     field: 'activation', type: 'actions', headerName: 'Activate', width: 100, renderCell: (params) => {
                        //         return <>
                        //             <Button variant='contained' onClick={() => setActivateCard(params.row.orderId as string)}>Activate</Button>
                        //         </>;
                        //     }
                        // },

                        // {
                        //     field: '', type: 'actions', headerName: 'Actions', width: 100, renderCell: (cell) => {
                        //         return <>
                        //             <Button variant='contained' onClick={() => setCardDetailsId(cell.id as string)}>Details</Button>
                        //         </>;
                        //     }
                        // },
                    ]}
                    rows={cards}

                    autoPageSize={true}
                    disableRowSelectionOnClick
                    getRowId={row => row.orderId}
                />
            </Grid>

        </Grid>

        {cardDetailsId && <CardDetailsModal cardId={cardDetailsId} onDetailsClose={(changed) => { 
            setCardDetailsId(null); 
            if (changed) {
                setDataRequested(false);
            }
            }} />}
        {/* {activateCard && <GetCardOrders orderId={activateCard} onClose={() => { setActivateCard(null); setDataRequested(false) }}></GetCardOrders>} */}


        {/* {activateCard && <ActivateCard cardId={activateCard} onClose={() => { setCardDetailsId(null); setDataRequested(false) }} />} */}


    </>;
}
